import { FileSchema, IFile } from "@app/api/files/helper-schemas";
import { store } from "index";
import {
	getDefaultStorageSettings,
	getDefaultReducer,
	filterByLoadTime,
	loadFromStorage,
	listenToLocalStorageChange,
} from "m-model-common";
import { getJoiObjectKeys, validateStorage } from "m-model-joi";
import { createModel, RawInstances, createCRUDActionTypes } from "m-model-core";
import { MAX_LOAD_TIME_DIFF, MIN_LOAD_TIME } from "./constants";
import { CourseCommonMetaInfo } from "./meta-info";

const keyOfId = "_id";
type IdKey = typeof keyOfId;
type DOC = IFile;
export type IStateFiles = RawInstances<IdKey, DOC>;

// ==============Base Model=================

const dockeys = getJoiObjectKeys<DOC>(FileSchema);
const storage = localStorage;
const actionTypes = createCRUDActionTypes("file");
const storageSettings = getDefaultStorageSettings("files");
const metaInformationName = "filesMetaInformation";

const isLoadedRecentlyEnough = filterByLoadTime(
	MAX_LOAD_TIME_DIFF,
	MIN_LOAD_TIME
);

const Model = createModel<IdKey, DOC>({
	keyOfId,
	getInstances: (() => store.getState().files) as any,
	dispatch: (action => store.dispatch(action)) as any,
	subscribe: (listener => store.subscribe(listener)) as any,
	actionTypes,
	dockeys,
	loadInstancesFromStorage: () =>
		loadFromStorage({
			storage,
			key: storageSettings.itemName,
			validateWholeData: validateStorage("ObjectId", FileSchema),
			filter: isLoadedRecentlyEnough,
		}),
});

// ==============Main Model=================

export class File extends Model {
	static initialize() {
		const info = super.initialize();
		if (info.loadedAll) this.meta.initialize();
		else this.meta.clear();
		return info;
	}

	static meta = new CourseCommonMetaInfo(storage, metaInformationName);
}

export type IFileInstance = File;
export type IFileModel = typeof File;

// ==============ETC=================

listenToLocalStorageChange(storage, metaInformationName, File.meta);

export const filesReducer = getDefaultReducer(storageSettings, () => File);
